import { sleep } from '@/modules/sleep';

// Bounded polling loop: sleeps, then awaits check(), repeating until check
// resolves true or maxAttempts run out — resolves to whether the condition
// was met. Built for post-tx indexer polls that must never wedge their
// completion cascade: timeout is a `false` return, never a throw. Errors
// thrown by `check` propagate to the caller unchanged.
export async function pollUntil(
  check: () => Promise<boolean>,
  {
    intervalMs,
    maxAttempts,
    sleepFn = sleep,
  }: {
    // Slept BEFORE every attempt, the first included.
    intervalMs: number;
    maxAttempts: number;
    sleepFn?: (ms: number) => Promise<void>;
  },
): Promise<boolean> {
  for (let i = 0; i < maxAttempts; i++) {
    await sleepFn(intervalMs);
    if (await check()) return true;
  }
  return false;
}
